export default [
  {
    path: '/active-gradereport/index',
    name: 'index',
    component: () => import('@/views/active-gradereport/index'),
    meta: {
      title: '广东一模分析报告'
    }
  },
  {
    path: '/active-gradereport/my-list',
    name: 'my-list',
    component: () => import('@/views/active-gradereport/my-list'),
    meta: {
      title: '广东一模分析报告'
    }
  },{
    path: '/active-gradereport/buy-record',
    name: 'buy-record',
    component: () => import('@/views/active-gradereport/buy-record'),
    meta: {
      title: '购买记录'
    }
  },{
    path: '/active-gradereport/about-our',
    name: 'about-our',
    component: () => import('@/views/active-gradereport/about-our'),
    meta: {
      title: '关于我们'
    }
  },{
    path: '/active-gradereport/msg-input',
    name: 'msg-input',
    component: () => import('@/views/active-gradereport/msg-input'),
    meta: {
      title: '信息填写'
    }
  },{
    path: '/active-gradereport/first-msg',
    name: 'first-msg',
    component: () => import('@/views/active-gradereport/first-msg'),
    meta: {
      title: '信息填写'
    }
  },{
    path: '/active-gradereport/grade-report',
    name: 'grade-report',
    component: () => import('@/views/active-gradereport/grade-report'),
    meta: {
      title: '成绩报告'
    }
  },{
    path: '/active-gradereport/pay',
    name: 'pay',
    component: () => import('@/views/active-gradereport/pay'),
    meta: {
      title: '支付'
    }
  },{
    path: '/active-gradereport/batch',
    name: 'batch',
    component: () => import('@/views/active-gradereport/batch'),
    meta: {
      title: '查批次'
    }
  },{
    path: '/active-gradereport/oneline',
    name: 'oneline',
    component: () => import('@/views/active-gradereport/oneline'),
    meta: {
      title: '一分一段'
    }
  },{
    path: '/active-gradereport/agreement',
    name: 'agreement',
    component: () => import('@/views/active-gradereport/agreement'),
    meta: {
      title: '协议内容'
    }
  },{
    path: '/active-gradereport/paySuccess',
    name: 'paySuccess',
    component: () => import('@/views/active-gradereport/paySuccess'),
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/active-gradereport/transit',
    name: 'transit',
    component: () => import('@/views/active-gradereport/transit'),
    meta: {
      title: ''
    }
  }
]
